import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeroSection from './components/HeroSection/HeroSection';
import HouseShowcase from './components/HouseShowcase/HouseShowcase';
import HouseConfigurator from './components/HouseConfigurator/HouseConfigurator';
import ProductMediaPage from './components/ProductMediaPage/ProductMediaPage';
import './App.css';

function HomePage() {
  return (
    <>
      <HeroSection />
    </>
  );
}

function ShowcasePage() {
  return (
    <>
      <HouseShowcase />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/showcase" element={<ShowcasePage />} />
          <Route path="/configure/:houseId" element={<HouseConfigurator />} />
          <Route path="/product-media" element={<ProductMediaPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
